import { SET_PLACES } from '../actions/PlacesAction'

const defaultSate = {
    items: [],
    isSet: false
};

const places = (state = defaultSate, action) => {
    let newState;

    switch (action.type)
    {
        case SET_PLACES:
            newState = {...state,
                items: action.places,
                isSet: true
            };
            break;
        default:
            newState = state;
            break;
    }

    return newState;
};

export default places;


// WEBPACK FOOTER //
// ./src/reducers/PlacesReducer.js